import { generateGravatarUrl, selectLocalFallback, SIZES } from './utils';

export function Gravatar({ email, size = 30, custom }) {
  const gravatarUrl =
    email &&
    generateGravatarUrl(email, size, custom || selectLocalFallback(email, size === 30 ? SIZES.SMALL : SIZES.LARGE));

  return <img src={gravatarUrl} alt="avatar" width={size} height={size} />;
}
